import { AxiosError } from 'axios';
import { APPX_ORG_API_URL } from '~/modules/config';
import { AuthTimeoutError } from '~/modules/errors/authErrors';
import { AddFavoriteError, RemoveFavoriteError } from '~/modules/errors/userErrors';
import { handleException } from '~/modules/utilities/error_utilities';
import { HttpRequestConfig, http } from '~/modules/utilities/http';
import { setupOrgRequestConfig } from '~/modules/utilities/httpUtilities';

export interface FavoriteListing {
    listingId: string;
    userId: string;
}

export class FavoriteListingsService {
    get endpoint(): string {
        return APPX_ORG_API_URL;
    }

    async addToFavorites(userId: string, listingId: string): Promise<string> {
        const favoriteListing = this.buildFavorite(userId, listingId);
        try {
            const request: HttpRequestConfig = setupOrgRequestConfig();
            const url = `${this.endpoint}/savedListings`;

            request.data = favoriteListing;

            const response = await http.post(url, request);
            return response.data;
        } catch (error) {
            handleException(error, 'FavoriteListingsService.addToFavorites');
            if ((error as AxiosError)?.response?.status === 403) {
                throw new AuthTimeoutError(`Failed to create favorite ${favoriteListing}`);
            } else {
                throw new AddFavoriteError(`Failed to create favorite ${JSON.stringify(favoriteListing)}`);
            }
        }
    }

    async removeFavorite(userId: string, listingId: string): Promise<void> {
        const favoriteListing = this.buildFavorite(userId, listingId);
        try {
            const request: HttpRequestConfig = setupOrgRequestConfig();
            const url = `${this.endpoint}/savedListings`;

            request.data = favoriteListing;

            await http.delete(url, request);
        } catch (error) {
            handleException(error, 'FavoriteListingsService.removeFavorite');
            if ((error as AxiosError)?.response?.status === 403) {
                throw new AuthTimeoutError(`Failed to delete favorite ${favoriteListing}`);
            } else {
                throw new RemoveFavoriteError(`Failed to delete favorite ${favoriteListing}`);
            }
        }
    }

    private buildFavorite(userId: string, listingId: string): FavoriteListing {
        const fav = {
            userId: userId,
            listingId: listingId,
        };
        return fav;
    }
}
